module.exports = __webpack_public_path__ + "img/charme_white_ba_list.7ccb996f.jpg";